import { Button } from '@mantine/core';
import { Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

interface ViewCitationsButtonProps {
  entityId: number;
  entityType: 'ARTICLE' | 'BOOK' | 'ABSTRACT' | 'TRANSLATION' | 'PROCEEDING' | 'CHAPTER';
}

export function ViewCitationsButton({ entityId, entityType }: ViewCitationsButtonProps) {
  const { t } = useTranslation();

  return (
    <div>
      <Button
        component={Link}
        to={`/author/${entityType.toLowerCase()}/${entityId}/citations`}
        variant="gradient"
        gradient={{ from: 'blue', to: 'cyan' }}
        size="xs"
      >
        {t('citations.viewCitations')}
      </Button>
    </div>
  );
}
